webpackJsonp([0],{

/***/ "/n/2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/product2.b5f4470.png";

/***/ }),

/***/ "/oiM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'contact'
});

/***/ }),

/***/ "0HDh":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/smarthouse2.85a6434.png";

/***/ }),

/***/ "0o1C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "17fK":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMS4xLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHdpZHRoPSI0N3B4IiBoZWlnaHQ9IjIxcHgiIHZpZXdCb3g9IjAgMCA0NyAyMSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDcgMjE7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+DQoJLnN0MHtmaWxsLXJ1bGU6ZXZlbm9kZDtjbGlwLXJ1bGU6ZXZlbm9kZDtmaWxsOiNGRkZGRkY7fQ0KPC9zdHlsZT4NCjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik0yMywyMUw0NiwybC00LTJMMjMsMTZMNCwwTDAsMkwyMywyMXoiLz4NCjwvc3ZnPg0K"

/***/ }),

/***/ "4t1x":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6EaV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AMzw":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "Cwn0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Product_vue__ = __webpack_require__("ctzt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cb28116_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Product_vue__ = __webpack_require__("bb4r");
function injectStyle (ssrContext) {
  __webpack_require__("vdOg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2cb28116"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Product_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cb28116_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Product_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "E5E/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"faq"},[_c('div',{staticClass:"container"},[_c('section',{staticClass:"section"},[_c('h3',{staticClass:"title"},[_vm._v("樂土Q&A")]),_vm._v(" "),_c('h6',{staticClass:"subtitle is-6"},[_vm._v("搜集網友對於樂土的疑問，一次完全暸解，重點整理大公開")]),_vm._v(" "),_c('div',{staticClass:"toolbar"},[_c('button',{staticClass:"button is-primary is-outlined",on:{"click":_vm.openAll}},[_vm._v("展開所有QA")]),_c('button',{staticClass:"button is-info is-outlined",on:{"click":_vm.collapseAll}},[_vm._v("關閉所有QA")])]),_vm._v(" "),_vm._l((_vm.questions),function(question){return _c('article',{staticClass:"media"},[_vm._m(0,true,false),_vm._v(" "),_c('div',{staticClass:"media-content "},[_c('div',{staticClass:"content question",on:{"click":function($event){question.collapsed = !question.collapsed}}},[_c('p',[_c('strong',[_vm._v(_vm._s(question.q))]),_c('button',{staticClass:"collapse"},[_c('i',{staticClass:"fa",class:[question.collapsed ? 'fa-angle-down' : 'fa-angle-up'],attrs:{"aria-hidden":"true"}})])])]),_vm._v(" "),_c('article',{directives:[{name:"show",rawName:"v-show",value:(!question.collapsed),expression:"!question.collapsed"}],staticClass:"media answer"},[_c('div',{staticClass:"media-content"},[_c('div',{staticClass:"content"},[_c('p',[_vm._v("\n                  "+_vm._s(question.a)+"\n                ")])])])])])])})],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"media-left"},[_c('p',{staticClass:"image icon"},[_c('i',{staticClass:"fa fa-question-circle",attrs:{"aria-hidden":"true"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "E61W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact"},[_c('section',[_c('iframe',{staticStyle:{"border":"0"},attrs:{"src":"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d28908.337710365027!2d121.5728658184064!3d25.083500672736335!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3442ac8cce7a9b6d%3A0x377d7129bd402c63!2zMTE05Y-w5YyX5biC5YWn5rmW5Y2A!5e0!3m2!1szh-TW!2stw!4v1511439341322","width":"100%","height":"450","frameborder":"0","allowfullscreen":""}})]),_vm._v(" "),_c('section',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-7 info"},[_c('h3',{staticClass:"subtitle is-2"},[_vm._v("世源科技有限公司")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("\b"),_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-map-marker",attrs:{"aria-hidden":"true"}})]),_vm._v("樂土材料皆宅配到指定地址，當天下午兩點前確認訂單，隔天可送達。")]),_vm._v(" "),_c('li',[_vm._v("\b"),_c('a',{attrs:{"href":"mailto:service@ezarch.com.tw"}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-envelope-o fa-lg",attrs:{"aria-hidden":"true"}})]),_vm._v("service@ezarch.com.tw")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"tel:0287976155"}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-phone fa-lg",attrs:{"aria-hidden":"true"}})]),_vm._v("02-87976155")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"tel:0931247688"}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-mobile fa-lg",attrs:{"aria-hidden":"true"}})]),_vm._v("0931-247-688")])]),_vm._v(" "),_c('li',[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-calendar",attrs:{"aria-hidden":"true"}})]),_vm._v("週一至週五 9:00-17:00")]),_vm._v(" "),_c('li',[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-comments",attrs:{"aria-hidden":"true"}})]),_vm._v("非服務時段請"),_c('a',{attrs:{"href":"https://line.me/ti/p/%40xqw0055x","target":"_blank"}},[_c('img',{staticClass:"line-icon",attrs:{"border":"0","alt":"好友人數","src":"https://scdn.line-apps.com/n/line_regulation/files/ver2/LINE_Icon.png","width":"36","height":"36"}})]),_vm._v("留言")])])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('div',{staticClass:"video-container"},[_c('iframe',{staticStyle:{"border":"none","overflow":"hidden"},attrs:{"src":"https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fezarchs&tabs&width=500&height=214&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=1350135241775221","width":"100%","height":"214","scrolling":"no","frameborder":"0","allowTransparency":"true"}})])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EMFf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Faq_vue__ = __webpack_require__("gjb/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09338ea0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Faq_vue__ = __webpack_require__("E5E/");
function injectStyle (ssrContext) {
  __webpack_require__("0o1C")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-09338ea0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Faq_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09338ea0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Faq_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "FnhZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__ = __webpack_require__("/oiM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39ce1383_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__ = __webpack_require__("E61W");
function injectStyle (ssrContext) {
  __webpack_require__("4t1x")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-39ce1383"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39ce1383_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Fs8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  data: function data() {
    return {
      heading: '成大樂土 源自台灣 新世代智慧防水建材',
      subheading: '水庫淤泥利用再生，防水透氣，環保無毒，能預防壁癌的神奇配方',
      products: [{ src: __webpack_require__("mmHi"), title: '抹壁型多效能防水粉', desc: '水泥防水添加劑', longdesc: '添加於水泥砂漿中，改善水泥砂漿先天不良的高吸水率問題，大幅降低吸水率到6%以下，並維持透氣性。', psrc: __webpack_require__("YHMn") }, { src: __webpack_require__("YDc5"), title: '樂土灰泥', desc: '泥礦創藝修飾砂漿', longdesc: '快速施工，輕易把非水泥質感的底材轉化成工業設計風的水泥質感，表面光滑，施作厚度僅有0.3-0.5mm。', psrc: __webpack_require__("/n/2") }, { src: __webpack_require__("JTha"), title: '樂繕薄層防水砂漿', desc: 'DIY修補', longdesc: '將牆面壁癌處刨除，並用本色樂繕打底，白色樂繕當面層，局部修補家中牆面病變處，含有工具組及說明書。', psrc: __webpack_require__("x+ht") }]
    };
  }
});

/***/ }),

/***/ "H3hf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IIO0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/lotos.f193dac.mp4";

/***/ }),

/***/ "JQaS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Lotos_vue__ = __webpack_require__("xG8C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63b092cc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Lotos_vue__ = __webpack_require__("UTmQ");
function injectStyle (ssrContext) {
  __webpack_require__("6EaV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-63b092cc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Lotos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63b092cc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Lotos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "JTha":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lotoslasan.bc0dd71.jpg";

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75bfb2e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("i1Jb");
function injectStyle (ssrContext) {
  __webpack_require__("VSuj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75bfb2e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "UTmQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lotos"},[_c('section',[_c('div',{staticClass:"movie-area"},[_c('figure',{staticClass:"image is-1by2"},[_c('video',{attrs:{"id":"movie","autoplay":"","preload":"","muted":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":__webpack_require__("IIO0"),"type":"video/mp4"}}),_vm._v("\n            您的瀏覽器不支援HTML 5影片播放標籤格式。\n            Your browser does not support the video tag.\n        ")])]),_vm._v(" "),_c('div',{attrs:{"id":"moreBtn"},on:{"click":_vm.scrollToContent}},[_c('img',{staticClass:"txt",attrs:{"src":__webpack_require__("AMzw")}}),_vm._v(" "),_c('img',{staticClass:"arrow",style:({marginTop: _vm.topValue + 'px'}),attrs:{"src":__webpack_require__("17fK")}})])])]),_vm._v(" "),_vm._m(0,false,false)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section main-content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"what-is-lotos columns boxed"},[_c('div',{staticClass:"column is-9"},[_c('h3',{staticClass:"title"},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-lightbulb-o",attrs:{"aria-hidden":"true"}})]),_vm._v("什麼是樂土材料？")]),_vm._v(" "),_c('p',[_vm._v("樂土是由國立成功大學土木系「輕質與結構材料試驗室」的專業研發團隊，歷經多年研發出「水庫淤泥再生改質技術」專利環保防水材料。樂土擁有極為特殊分子結構，透過疏導透氣代替傳統防堵模式，讓建材兼顧防水透氣強大功能，不管是正負水壓的狀況均能處理，適用於各種建物的多元防水需求。")]),_vm._v(" "),_c('p',[_vm._v("同時材料本質穩定長久，完全針對台灣潮濕氣候設計，有效克服台灣建物防水難題。使用樂土的房屋，就如同穿上戶外機能性的GORE-TEX科技布料一般，讓建物具備透氣呼吸功效，強化防水/防潮效果且大幅提升您的居住品質。")])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('figure',{staticClass:"image is-1by1"},[_c('img',{attrs:{"src":__webpack_require__("oKJ3")}})])])]),_vm._v(" "),_c('div',{staticClass:"how-lotos-work columns boxed"},[_c('div',{staticClass:"column is-7"},[_c('h3',{staticClass:"title"},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-lightbulb-o",attrs:{"aria-hidden":"true"}})]),_vm._v("樂土的運作原理")]),_vm._v(" "),_c('p',[_vm._v("樂土的防水微粒，是來自水庫淤泥進行科技材料改質，擁有微米接近奈米等級的極細結構。具有物理斥水效果。加入水泥砂漿攪拌均勻後，每平方公尺水泥砂漿含有一億個斥水微粒，樂土斥水微粒能將任何水滴阻擋於外，卻仍保留水泥砂漿透氣度與毛孔作用，達到防水透氣效果！以疏導代替防堵解決以往建築難解之防水難題。")])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('figure',{staticClass:"image is-2by1"},[_c('img',{attrs:{"src":__webpack_require__("hAOF")}})])])]),_vm._v(" "),_c('div',{staticClass:"lotos-good columns boxed"},[_c('div',{staticClass:"column"},[_c('h3',{staticClass:"title"},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-thumbs-o-up",attrs:{"aria-hidden":"true"}})]),_vm._v("材料優點")]),_vm._v(" "),_c('ul',[_c('li',{staticClass:"anti"},[_c('p',[_vm._v("將無機質防水材料，以樂土斥水特性透過物理反應將砂漿轉化為防水層，卻仍不會破壞砂漿性質！")])]),_vm._v(" "),_c('li',{staticClass:"beauty"},[_c('p',[_vm._v("樂土提升建築外觀美感。經專業測試可抵抗三十米正負水壓。兼具防水防潮，抗白華預防壁癌等效果。")])]),_vm._v(" "),_c('li',{staticClass:"air"},[_c('p',[_vm._v("保留透氣性，不阻塞材質自然孔隙讓建物擁有絕佳的防水性，更能保有仿呼吸性能，不讓水氣滯留於結構內。")])]),_vm._v(" "),_c('li',{staticClass:"weather"},[_c('p',[_vm._v("添加樂土的砂漿，對於熱漲冷縮造成的微小裂縫不會影響防水性，再極端變化環境中，仍保有良好適應性。")])]),_vm._v(" "),_c('li',{staticClass:"longterm"},[_c('p',[_vm._v("樂土是非常安定的無機質，在施作後結構可持續保持防水效能50年以上而且不受風吹日曬雨淋而退化。")])]),_vm._v(" "),_c('li',{staticClass:"cheap"},[_c('p',[_vm._v("無須多餘工種，降低現場管理成本。每平方公尺施工成本不到55元，遠低於其他防水材料。")])])])])]),_vm._v(" "),_c('div',{staticClass:"lotos-app columns boxed"},[_c('div',{staticClass:"column is-8"},[_c('h3',{staticClass:"title"},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-wrench",attrs:{"aria-hidden":"true"}})]),_vm._v("聰明防水工法")]),_vm._v(" "),_c('ul',{staticClass:"first"},[_c('li',[_c('p',[_vm._v("老舊建物垂流面外牆防水失效，不須外部重新施作防水，只需內部砂漿添加樂土防水粉抹壁，即可解決內部壁癌問題。")])]),_vm._v(" "),_c('li',[_c('p',[_vm._v("建築室內牆壁 地下室 浴室 磁磚及窗框防水工程。")])]),_vm._v(" "),_c('li',[_c('p',[_vm._v("各種防水 防潮抗白華及預防壁癌的防治處理。")])])]),_vm._v(" "),_c('div',{staticClass:"columns"},[_c('article',{staticClass:"message column"},[_c('div',{staticClass:"message-header"},[_c('p',[_vm._v("實作範例")])]),_vm._v(" "),_c('div',{staticClass:"message-body"},[_c('ol',{staticClass:"second column"},[_c('li',[_c('p',[_vm._v("外牆：樂土防水透氣砂漿水泥粉刷打底")])]),_vm._v(" "),_c('li',[_c('p',[_vm._v("室內牆：採用樂土防水透氣水泥粉刷打底粉光")])]),_vm._v(" "),_c('li',[_c('p',[_vm._v("建築外牆：維持原來砌磚不施作水泥粉刷")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('figure',{staticClass:"image is-1by1"},[_c('img',{attrs:{"src":__webpack_require__("0HDh")}})])])]),_vm._v(" "),_c('div',{staticClass:"lotos-reporting boxed"},[_c('h3',{staticClass:"title"},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-newspaper-o",attrs:{"aria-hidden":"true"}})]),_vm._v("媒體報導")]),_vm._v(" "),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:" video-container"},[_c('iframe',{attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/EpnjdLnfdrA?rel=0&showinfo=0","frameborder":"0","allowfullscreen":""}})])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('div',{staticClass:" video-container"},[_c('iframe',{attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/vbNPsmuiC84?rel=0&showinfo=0","frameborder":"0","allowfullscreen":""}})])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VSuj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YDc5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lotospaster4.81e1621.jpg";

/***/ }),

/***/ "YHMn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/product1.02347e5.png";

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_analytics__ = __webpack_require__("AYPi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Home__ = __webpack_require__("lO7g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Faq__ = __webpack_require__("EMFf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Product__ = __webpack_require__("Cwn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Contact__ = __webpack_require__("FnhZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Lotos__ = __webpack_require__("JQaS");









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Home',
    component: function component(resolve) {
      return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("lO7g")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { title: 'EZARCH 樂土專業販售' }
  }, {
    path: '/faq',
    name: 'Faq',
    component: function component(resolve) {
      return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("EMFf")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { title: '樂土Q&A - EZARCH 樂土專業販售' }
  }, {
    path: '/product',
    name: 'Product',
    component: function component(resolve) {
      return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Cwn0")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { title: '樂土產品列表 - EZARCH 樂土專業販售' }
  }, {
    path: '/contact',
    name: 'Contact',
    component: function component(resolve) {
      return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("FnhZ")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { title: '聯絡我們 - EZARCH 樂土專業販售' }
  }, {
    path: '/lotos',
    name: 'Lotos',
    component: function component(resolve) {
      return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("JQaS")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { title: '什麼是樂土？ - EZARCH 樂土專業販售' }
  }]
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_analytics___default.a, {
  id: 'UA-39498232-1',
  router: router
});

router.beforeEach(function (to, from, next) {
  window.document.title = to.meta.title;
  next();
});
/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "YrcL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/healthy.13a14ae.png";

/***/ }),

/***/ "bb4r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product"},[_c('div',{staticClass:"container"},[_c('section',{staticClass:"section"},[_c('h3',{staticClass:"title"},[_vm._v("樂土產品列表")]),_vm._v(" "),_c('div',{staticClass:"pd-info"},[_c('table',{staticClass:"table is-striped is-fullwidth is-responsive"},[_c('thead',[_c('tr',[_c('th',[_c('abbr',{attrs:{"title":"產品名稱"}},[_vm._v("產品名稱")])]),_vm._v(" "),_c('th',[_c('abbr',{attrs:{"title":"產品用途"}},[_vm._v("產品用途")])]),_vm._v(" "),_c('th',[_c('abbr',{attrs:{"title":"包裝重量"}},[_vm._v("包裝重量")])]),_vm._v(" "),_c('th',[_c('abbr',{attrs:{"title":"售價"}},[_vm._v("售價(NTD)")])]),_vm._v(" "),_c('th',[_c('abbr',{attrs:{"title":"施作面積"}},[_vm._v("施作面積(㎡)")])]),_vm._v(" "),_c('th',[_c('abbr',{attrs:{"title":"費用"}},[_vm._v("費用(元/㎡)")])]),_vm._v(" "),_c('th',[_c('abbr',{attrs:{"title":"購買"}},[_vm._v("購買連結")])])])]),_vm._v(" "),_c('tfoot',[_c('tr',[_c('th',[_c('abbr',{attrs:{"title":"產品名稱"}},[_vm._v("產品名稱")])]),_vm._v(" "),_c('th',[_c('abbr',{attrs:{"title":"產品用途"}},[_vm._v("產品用途")])]),_vm._v(" "),_c('th',[_c('abbr',{attrs:{"title":"包裝重量"}},[_vm._v("包裝重量")])]),_vm._v(" "),_c('th',[_c('abbr',{attrs:{"title":"售價"}},[_vm._v("售價(NTD)")])]),_vm._v(" "),_c('th',[_c('abbr',{attrs:{"title":"施作面積"}},[_vm._v("施作面積(㎡)")])]),_vm._v(" "),_c('th',[_c('abbr',{attrs:{"title":"費用"}},[_vm._v("費用(元/㎡)")])]),_vm._v(" "),_c('th',[_c('abbr',{attrs:{"title":"購買"}},[_vm._v("購買連結")])])])]),_vm._v(" "),_c('tbody',[_c('tr',{staticClass:"is-selected"},[_c('th',{attrs:{"colspan":"7"}},[_vm._v("水泥砂漿專用防水添加劑")])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("通用型多效能防水粉")]),_vm._v(" "),_c('td',[_vm._v("適用於各類材料的防水添加劑，或無水泥攪拌器(土牛)時地坪使用")]),_vm._v(" "),_c('td',[_vm._v("2kg/包")]),_vm._v(" "),_c('td',[_vm._v("NT$ 330")]),_vm._v(" "),_c('td',[_vm._v("粗胚1.5cm = 7㎡ "),_c('br'),_vm._v("粉光0.5cm = 21㎡ ")]),_vm._v(" "),_c('td',[_vm._v("47"),_c('br'),_vm._v("16")]),_vm._v(" "),_c('td',[_c('a',{staticClass:"button is-primary is-outlined call-in-action",attrs:{"href":"https://shop.ezarch.com.tw/%E6%A8%82%E5%9C%9F%E9%80%9A%E7%94%A8%E5%9E%8B%E9%98%B2%E6%B0%B4%E7%B2%89","target":"_blank"}},[_vm._v("購買")])])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("抹壁型多效能防水粉")]),_vm._v(" "),_c('td',[_vm._v("抹壁砂漿專用水泥防水添加劑")]),_vm._v(" "),_c('td',[_vm._v("2kg/包")]),_vm._v(" "),_c('td',[_vm._v("NT$ 380")]),_vm._v(" "),_c('td',[_vm._v("粗胚1.5cm = 7㎡ "),_c('br'),_vm._v("粉光0.5cm = 21㎡ ")]),_vm._v(" "),_c('td',[_vm._v("50"),_c('br'),_vm._v("18")]),_vm._v(" "),_c('td',[_c('a',{staticClass:"button is-primary is-outlined call-in-action",attrs:{"href":"https://shop.ezarch.com.tw/%E6%A8%82%E5%9C%9F%E6%8A%B9%E5%A3%81%E5%9E%8B%E9%98%B2%E6%B0%B4%E7%B2%89","target":"_blank"}},[_vm._v("購買")])])]),_vm._v(" "),_c('tr',{staticClass:"is-selected"},[_c('th',{attrs:{"colspan":"7"}},[_vm._v("泥墨泥礦漆礦物塗料")])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("泥礦漆礦物塗料1 Gal")]),_vm._v(" "),_c('td',[_vm._v("MIT礦物塗料健康無毒無甲醛無VOC自潔")]),_vm._v(" "),_c('td',[_vm._v("1 Gal/桶")]),_vm._v(" "),_c('td',[_vm._v("NT$ 3360")]),_vm._v(" "),_c('td',[_vm._v("20㎡")]),_vm._v(" "),_c('td',[_vm._v("168")]),_vm._v(" "),_c('td',[_c('a',{staticClass:"button is-primary is-outlined call-in-action",attrs:{"href":"https://shop.ezarch.com.tw/%E6%B3%A5%E5%A2%A8%E6%B3%A5%E7%A4%A6%E6%BC%86","target":"_blank"}},[_vm._v("購買")])])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("泥礦漆礦物塗料5 Gal")]),_vm._v(" "),_c('td',[_vm._v("MIT礦物塗料健康無毒無甲醛無VOC自潔")]),_vm._v(" "),_c('td',[_vm._v("5 Gal/桶")]),_vm._v(" "),_c('td',[_vm._v("NT$ 14700")]),_vm._v(" "),_c('td',[_vm._v("95㎡")]),_vm._v(" "),_c('td',[_vm._v("155")]),_vm._v(" "),_c('td',[_c('a',{staticClass:"button is-primary is-outlined call-in-action",attrs:{"href":"https://shop.ezarch.com.tw/%E6%B3%A5%E5%A2%A8%E6%B3%A5%E7%A4%A6%E6%BC%86","target":"_blank"}},[_vm._v("購買")])])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("泥礦漆專用透氣底漆5 Gal")]),_vm._v(" "),_c('td',[_vm._v("健康無毒透氣")]),_vm._v(" "),_c('td',[_vm._v("5 Gal/桶")]),_vm._v(" "),_c('td',[_vm._v("NT$ 3360")]),_vm._v(" "),_c('td',[_vm._v("95㎡")]),_vm._v(" "),_c('td',[_vm._v("36")]),_vm._v(" "),_c('td',[_c('a',{staticClass:"button is-primary is-outlined call-in-action",attrs:{"href":"https://shop.ezarch.com.tw/%E6%B3%A5%E7%A4%A6%E6%BC%86%E5%B0%88%E7%94%A8%E9%80%8F%E6%B0%A3%E5%BA%95%E6%BC%86","target":"_blank"}},[_vm._v("購買")])])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("泥礦漆專用透氣底漆1 Gal")]),_vm._v(" "),_c('td',[_vm._v("健康無毒透氣")]),_vm._v(" "),_c('td',[_vm._v("1 Gal/桶")]),_vm._v(" "),_c('td',[_vm._v("NT$ 840")]),_vm._v(" "),_c('td',[_vm._v("19㎡")]),_vm._v(" "),_c('td',[_vm._v("45")]),_vm._v(" "),_c('td',[_c('a',{staticClass:"button is-primary is-outlined call-in-action",attrs:{"href":"https://shop.ezarch.com.tw/%E6%B3%A5%E7%A4%A6%E6%BC%86%E5%B0%88%E7%94%A8%E9%80%8F%E6%B0%A3%E5%BA%95%E6%BC%86","target":"_blank"}},[_vm._v("購買")])])]),_vm._v(" "),_c('tr',{staticClass:"is-selected"},[_c('th',{attrs:{"colspan":"7"}},[_vm._v("樂土灰泥及週邊")])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("樂土灰泥 絲綢版"),_c('span',{staticClass:"color-note"},[_vm._v("(樂土白 清水灰 樂土灰 水泥灰)")])]),_vm._v(" "),_c('td',[_vm._v("超薄表面修飾砂漿")]),_vm._v(" "),_c('td',[_vm._v("5kg/包")]),_vm._v(" "),_c('td',[_vm._v("NT$ 1250")]),_vm._v(" "),_c('td',[_vm._v("5㎡ ")]),_vm._v(" "),_c('td',[_vm._v("250")]),_vm._v(" "),_c('td',[_c('a',{staticClass:"button is-primary is-outlined call-in-action",attrs:{"href":"https://shop.ezarch.com.tw/%E6%A8%82%E5%9C%9F%E7%81%B0%E6%B3%A55kg","target":"_blank"}},[_vm._v("購買")])])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("樂土灰泥 絨布版"),_c('span',{staticClass:"color-note"},[_vm._v("(珍珠白 菊島灰 鮮奶茶 珊瑚粉 海洋灰)")])]),_vm._v(" "),_c('td',[_vm._v("超薄表面修飾砂漿")]),_vm._v(" "),_c('td',[_vm._v("5kg/包")]),_vm._v(" "),_c('td',[_vm._v("NT$ 1400")]),_vm._v(" "),_c('td',[_vm._v("5㎡ ")]),_vm._v(" "),_c('td',[_vm._v("280")]),_vm._v(" "),_c('td',[_c('a',{staticClass:"button is-primary is-outlined call-in-action",attrs:{"href":"https://shop.ezarch.com.tw/%E7%B5%A8%E5%B8%83%E5%9E%8B%E6%96%B0%E7%89%88%E6%A8%82%E5%9C%9F%E7%81%B0%E6%B3%A5","target":"_blank"}},[_vm._v("購買")])])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("灰泥作業改良劑")]),_vm._v(" "),_c('td',[_vm._v("增加灰泥工作緩凝滑順性能")]),_vm._v(" "),_c('td',[_vm._v("1.8kg/桶")]),_vm._v(" "),_c('td',[_vm._v("NT$ 1050")]),_vm._v(" "),_c('td',[_vm._v("抹鏝對應3包5kg灰泥，噴滾塗對應1包5kg灰泥")]),_vm._v(" "),_c('td',[_vm._v("n/a")]),_vm._v(" "),_c('td',[_c('a',{staticClass:"button is-primary is-outlined call-in-action",attrs:{"href":"https://shop.ezarch.com.tw/%E6%A8%82%E5%9C%9F%E7%81%B0%E6%B3%A5%E4%BD%9C%E6%A5%AD%E6%94%B9%E8%89%AF%E5%8A%91","target":"_blank"}},[_vm._v("購買")])])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("TOP面塗")]),_vm._v(" "),_c('td',[_vm._v("輕度霧面潑水保護")]),_vm._v(" "),_c('td',[_vm._v("1.8L/桶")]),_vm._v(" "),_c('td',[_vm._v("NT$ 650")]),_vm._v(" "),_c('td',[_vm._v("12㎡")]),_vm._v(" "),_c('td',[_vm._v("54.17")]),_vm._v(" "),_c('td',[_c('a',{staticClass:"button is-primary is-outlined call-in-action",attrs:{"href":"https://shop.ezarch.com.tw/%E6%A8%82%E5%9C%9FTOP%E9%9D%A2%E5%A1%97%E6%B0%B4%E6%80%A7%E9%98%B2%E8%AD%B7","target":"_blank"}},[_vm._v("購買")])])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("F93無機防護面塗")]),_vm._v(" "),_c('td',[_vm._v("成膜霧面強化保護")]),_vm._v(" "),_c('td',[_vm._v("1L/桶")]),_vm._v(" "),_c('td',[_vm._v("NT$ 1680")]),_vm._v(" "),_c('td',[_vm._v("12㎡")]),_vm._v(" "),_c('td',[_vm._v("140")]),_vm._v(" "),_c('td',[_c('a',{staticClass:"button is-primary is-outlined call-in-action",attrs:{"href":"https://shop.ezarch.com.tw/%E6%B3%A5%E5%A2%A8F93%E7%84%A1%E6%A9%9F%E9%98%B2%E8%AD%B7%E9%9D%A2%E5%A1%97","target":"_blank"}},[_vm._v("購買")])])]),_vm._v(" "),_c('tr',{staticClass:"is-selected"},[_c('th',{attrs:{"colspan":"7"}},[_vm._v("防水介面塗層")])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("樂塗防水透氣漆")]),_vm._v(" "),_c('td',[_vm._v("戶外屋頂 外牆壁面防水塗層")]),_vm._v(" "),_c('td',[_vm._v("18kg/桶"),_c('br'),_vm._v("4kg/桶")]),_vm._v(" "),_c('td',[_vm._v("NT$ 2100"),_c('br'),_vm._v("NT$ 500")]),_vm._v(" "),_c('td',[_vm._v("45㎡"),_c('br'),_vm._v("9㎡")]),_vm._v(" "),_c('td',[_vm._v("52.5"),_c('br'),_vm._v("5.5")]),_vm._v(" "),_c('td',[_c('a',{staticClass:"button is-primary is-outlined call-in-action",attrs:{"href":"https://shop.ezarch.com.tw/%E6%A8%82%E5%A1%97%E9%98%B2%E6%B0%B4%E9%80%8F%E6%B0%A3%E6%BC%86","target":"_blank"}},[_vm._v("購買")])])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("樂天BB漆")]),_vm._v(" "),_c('td',[_vm._v("戶外屋頂隔熱防水塗層")]),_vm._v(" "),_c('td',[_vm._v("20kg/桶"),_c('br'),_vm._v("4kg/桶")]),_vm._v(" "),_c('td',[_vm._v("NT$ 2450"),_c('br'),_vm._v("NT$ 650")]),_vm._v(" "),_c('td',[_vm._v("50㎡"),_c('br'),_vm._v("10㎡")]),_vm._v(" "),_c('td',[_vm._v("49"),_c('br'),_vm._v("65")]),_vm._v(" "),_c('td',[_c('a',{staticClass:"button is-primary is-outlined call-in-action",attrs:{"href":"https://shop.ezarch.com.tw/%E6%A8%82%E5%A4%A9BB%E9%98%B2%E6%B0%B4%E9%9A%94%E7%86%B1%E6%BC%86","target":"_blank"}},[_vm._v("購買")])])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("單組份彈性水泥")]),_vm._v(" "),_c('td',[_vm._v("浴室屋頂防水中塗層")]),_vm._v(" "),_c('td',[_vm._v("5Gal/桶"),_c('br'),_vm._v("1 Gal/桶")]),_vm._v(" "),_c('td',[_vm._v("NT$ 1550"),_c('br'),_vm._v("NT$ 480")]),_vm._v(" "),_c('td',[_vm._v("18㎡"),_c('br'),_vm._v("4㎡")]),_vm._v(" "),_c('td',[_vm._v("86"),_c('br'),_vm._v("120")]),_vm._v(" "),_c('td',[_c('a',{staticClass:"button is-primary is-outlined call-in-action",attrs:{"href":"https://shop.ezarch.com.tw/%E6%A8%82%E5%9C%9F%E5%96%AE%E7%B5%84%E4%BB%BD%E5%BD%88%E6%80%A7%E6%B0%B4%E6%B3%A5","target":"_blank"}},[_vm._v("購買")])])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("水性介面接著底漆")]),_vm._v(" "),_c('td',[_vm._v("粉化或水泥地面打底塗層")]),_vm._v(" "),_c('td',[_vm._v("5Gal/桶"),_c('br'),_vm._v("1 Gal/桶")]),_vm._v(" "),_c('td',[_vm._v("NT$ 2350"),_c('br'),_vm._v("NT$ 580")]),_vm._v(" "),_c('td',[_vm._v("150㎡"),_c('br'),_vm._v("35㎡")]),_vm._v(" "),_c('td',[_vm._v("15.6"),_c('br'),_vm._v("16.57")]),_vm._v(" "),_c('td',[_c('a',{staticClass:"button is-primary is-outlined call-in-action",attrs:{"href":"https://shop.ezarch.com.tw/%E6%B0%B4%E6%80%A7%E7%95%8C%E9%9D%A2%E6%8E%A5%E8%91%97%E5%BA%95%E6%BC%86","target":"_blank"}},[_vm._v("購買")])])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("矽酸質塗佈型防水材WP-800")]),_vm._v(" "),_c('td',[_vm._v("負水壓打底塗層")]),_vm._v(" "),_c('td',[_vm._v("25kg/包"),_c('br'),_vm._v("5kg/包")]),_vm._v(" "),_c('td',[_vm._v("NT$3800"),_c('br'),_vm._v("NT$ 800")]),_vm._v(" "),_c('td',[_vm._v("16.6㎡"),_c('br'),_vm._v("3.32㎡")]),_vm._v(" "),_c('td',[_vm._v("229"),_c('br'),_vm._v("240")]),_vm._v(" "),_c('td',[_c('a',{staticClass:"button is-primary is-outlined call-in-action",attrs:{"href":"https://shop.ezarch.com.tw/%E7%9F%BD%E9%85%B8%E8%B3%AA%E5%A1%97%E4%BD%88%E5%9E%8B%E9%98%B2%E6%B0%B4%E6%9D%90WP-800","target":"_blank"}},[_vm._v("購買")])])]),_vm._v(" "),_c('tr',{staticClass:"is-selected"},[_c('th',{attrs:{"colspan":"7"}},[_vm._v("壁癌處理專用超薄防水沙漿")])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("DIY壁癌專用工具組2kg")]),_vm._v(" "),_c('td',[_vm._v("內含本色樂繕1kg及白色樂繕1kg及工具組說明書")]),_vm._v(" "),_c('td',[_vm._v("2kg/桶")]),_vm._v(" "),_c('td',[_vm._v("NT$ 310")]),_vm._v(" "),_c('td',[_vm._v("1㎡")]),_vm._v(" "),_c('td',[_vm._v("310")]),_vm._v(" "),_c('td',[_c('a',{staticClass:"button is-primary is-outlined call-in-action",attrs:{"href":"https://shop.ezarch.com.tw/%E6%A8%82%E7%B9%95%E8%B6%85%E8%96%84%E6%8A%B9%E9%9D%A2%E7%A0%82%E6%BC%BF2kg%E5%8F%8A%E5%B7%A5%E5%85%B7%E7%B5%84%E5%90%88","target":"_blank"}},[_vm._v("購買")])])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("白色樂繕")]),_vm._v(" "),_c('td',[_vm._v("防水透氣批土")]),_vm._v(" "),_c('td',[_vm._v("5kg/包")]),_vm._v(" "),_c('td',[_vm._v("NT$ 400")]),_vm._v(" "),_c('td',[_vm._v("10-15㎡")]),_vm._v(" "),_c('td',[_vm._v("27-40")]),_vm._v(" "),_c('td',[_c('a',{staticClass:"button is-primary is-outlined call-in-action",attrs:{"href":"https://shop.ezarch.com.tw/%E6%A8%82%E7%B9%95%E7%99%BD%E8%89%B25kg","target":"_blank"}},[_vm._v("購買")])])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("本色樂繕")]),_vm._v(" "),_c('td',[_vm._v("牆面地面整平打底")]),_vm._v(" "),_c('td',[_vm._v("5kg/包")]),_vm._v(" "),_c('td',[_vm._v("NT$ 360")]),_vm._v(" "),_c('td',[_vm._v("5㎡")]),_vm._v(" "),_c('td',[_vm._v("72")]),_vm._v(" "),_c('td',[_c('a',{staticClass:"button is-primary is-outlined call-in-action",attrs:{"href":"https://shop.ezarch.com.tw/%E6%A8%82%E7%B9%95%E6%9C%AC%E8%89%B25kg","target":"_blank"}},[_vm._v("購買")])])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "c/By":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('section',{staticClass:"hero is-primary is-medium"},[_c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"title"},[_vm._v("\n          "+_vm._s(_vm.heading)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"is-two-thirds column is-paddingless"},[_c('h2',{staticClass:"subtitle is-4"},[_vm._v(_vm._s(_vm.subheading))])]),_vm._v(" "),_c('div',{staticClass:"is-half column lotos"},[_c('router-link',{staticClass:"button lotos-more is-info is-medium",attrs:{"to":"/lotos","id":"learn"}},[_c('span',{staticClass:"text"},[_vm._v("了解更多")]),_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-arrow-right",attrs:{"aria-hidden":"true"}})])])],1)])])]),_vm._v(" "),_c('section',{staticClass:"section"},[_c('div',{staticClass:"container"},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"columns pd"},_vm._l((_vm.products),function(product){return _c('div',{staticClass:"column"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-image"},[_c('figure',{staticClass:"image is-3by4"},[_c('img',{attrs:{"src":product.src,"alt":"Placeholder image"}})])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"media"},[_c('div',{staticClass:"media-left"},[_c('figure',{staticClass:"image is-48x48"},[_c('img',{attrs:{"src":product.psrc,"alt":"Placeholder image"}})])]),_vm._v(" "),_c('div',{staticClass:"media-content"},[_c('p',{staticClass:"title is-4"},[_vm._v(_vm._s(product.title))]),_vm._v(" "),_c('p',{staticClass:"subtitle is-6"},[_vm._v(_vm._s(product.desc))])])]),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._v("\n                  "+_vm._s(product.longdesc)+"\n              ")])])])])}))])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tile is-ancestor special-charact"},[_c('div',{staticClass:"tile is-parent is-6"},[_c('article',{staticClass:"tile is-child"},[_c('figure',{staticClass:"image"},[_c('img',{attrs:{"src":__webpack_require__("YrcL")}})])])]),_vm._v(" "),_c('div',{staticClass:"tile is-parent is-vertical"},[_c('article',{staticClass:"tile is-child notification box"},[_c('p',{staticClass:"title"},[_vm._v("首創健康仿生宅概念")]),_vm._v(" "),_c('p',[_vm._v("建築物的外牆水泥砂漿添加樂土,如同戶外服飾的設計理念,仿生兼具防水透氣的功能,是建築材料設計的靈魂。")])]),_vm._v(" "),_c('article',{staticClass:"tile is-child notification box "},[_c('p',{staticClass:"title"},[_vm._v("建築界的GORE-TEX")]),_vm._v(" "),_c('p',[_vm._v("完全針對台灣潮濕氣候設計的樂土，強化防水/防潮效果。如同穿上戶外機能性的GORE-TEX科技布料一般，讓建築具備透氣呼吸功效。")])]),_vm._v(" "),_c('article',{staticClass:"tile is-child notification box"},[_c('p',{staticClass:"title"},[_vm._v("施作比例")]),_vm._v(" "),_c('p',[_vm._v("於水泥砂漿攪拌時，將2kg包裝的樂土防水粉混合一起加入攪拌均勻即可，樂土防水粉/水泥砂漿的比例為一包50kg的水泥配一包2kg的防水粉乾伴均勻後，再加上水與砂攪拌均勻才能施作喔！")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ctzt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'product'
});

/***/ }),

/***/ "gjb/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'faq',
  data: function data() {
    return {
      questions: [{ q: '什麼是樂土？', a: '樂土是利用水庫淤泥改質後製作成斥水性的微粒子，加入水泥砂漿中，在不影響水泥砂漿原有的透氣性下，以斥水性的物理力讓水滴不能通過而水氣卻可以通過，使水泥砂漿吸水率降低，改善水泥砂漿的體質，讓水泥砂漿防水透氣。', collapsed: true }, { q: '如何使用樂土於外牆防水工程呢 ？', a: '最簡單的做法即是在外牆抹壁的粗胚1:3砂漿中加入防水粉，即可使建築外牆砂漿具防水透氣性能。', collapsed: true }, { q: '如何使用樂土防水粉？', a: '只要謹記口訣一包對一包即可，意思是一包50kg的水泥對一包2kg的防水粉，水與砂另外加入，充分攪拌混合即可。禁用噴固精與機仔粉！', collapsed: true }, { q: '樂土產品到底有哪些？', a: '以樂土為核心原料所衍生出的產品一共有二十幾樣喔，其中最被大家所認識的為「樂土多效能防水粉」與「樂土灰泥」，詳情可以查看我們的樂土產品列表。', collapsed: true }, { q: '使用防水粉禁止添加噴固精或機仔粉？', a: '是的，因為這兩項常見的水泥砂漿潤滑劑都會使得砂漿的強度下降，蓬鬆率提高，故吸水率也會跟著提高，但樂土本身是降低砂漿吸水率使，這樣等於沒加，另外樂土防水粉本身就有自帶潤滑的效果。', collapsed: true }, { q: '樂土防水粉有幾種？為什麼會有區別？', a: '樂土防水粉有三種，分別是「抹壁用多效能防水粉 2kg包」「通用型多效能防水粉 2kg包」與「防水土粉 3kg包」，顧名思義抹壁用就是讓施作牆面抹壁時工作性能跟原來師傅施作的習慣一至，通用型一般可以添加於益膠泥 填縫泥 或是地面水泥砂漿在無俗稱土牛的攪拌平台時使用，防水土粉是濕粉，故最常使用的地方就是具備土牛攪拌平台時的地面水泥砂漿使用。', collapsed: true }, { q: '樂土防水粉是什麼顏色？', a: '正常的樂土防水粉都是水泥本色 灰色的意思，但是如果需要白色的通用防水粉，我們也可以提供。', collapsed: true }, { q: '樂土仿清水模效果是何種材料？', a: '這是「樂土灰泥」的效果喔，「樂土灰泥」為一種薄層修飾砂漿，施作厚度只有0.3mm-0.5mm，可以很輕易的把不是水泥質感的牆面地面或是木造，轉化成水泥的質感。', collapsed: true }, { q: '樂土灰泥有幾種顏色？', a: '四種，分別是樂土白 清水灰 樂土灰 水泥水，樂土白不是純白而是帶灰的白色，清水灰為淺偏冷的灰色，樂土灰為帶黃偏暖的略淺水泥灰，水泥灰顧名思義為最接近水泥粉光的灰色', collapsed: true }, { q: '樂土施工是否需要特殊工班？', a: '不需要，所有的樂土產品都是設計成無特殊做法，不需特殊工班即可施工，只需要合格的手藝與一顆接受樂土的心。', collapsed: true }, { q: '如何使用樂土灰泥來搭配工業風設計？', a: '樂土灰泥的設計理念是薄層修飾砂漿，可以輕易的將舊的油漆粉刷牆面 板材造型牆面或吧台 甚至非水泥質感之底材，輕易的轉化成水泥的質感，施作厚度只有0.3-0.5mm。', collapsed: true }, { q: '請問有實體門市嗎？', a: '我們並無實體門市，以網路販售為主，所有樂土產品全省都可以宅配到指定地址。', collapsed: true }, { q: '樂土產品最快何時可以送到？', a: '當天下午兩點確認訂單完成匯款手續，最快隔天中午前可以送達。', collapsed: true }]
    };
  },
  methods: {
    openAll: function openAll() {
      for (var i = 0, j = this.questions.length; i < j; i++) {
        this.questions[i].collapsed = false;
      }
    },
    collapseAll: function collapseAll() {
      for (var i = 0, j = this.questions.length; i < j; i++) {
        this.questions[i].collapsed = true;
      }
    }
  }
});

/***/ }),

/***/ "hAOF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lotosworks2.357bdf5.png";

/***/ }),

/***/ "i1Jb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('header',[_c('div',{staticClass:"navbar has-shadow"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-brand"},[_c('h1',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("EZARCH")]),_vm._m(0,false,false)],1),_c('em',[_vm._v("防水 透氣 環保 耐久")]),_vm._v(" "),_c('span',{staticClass:"navbar-burger",class:{ 'is-active' : _vm.isActive },on:{"click":_vm.toggleNav}},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])])])]),_vm._v(" "),_c('nav',{attrs:{"id":"navigate","role":"navigation","aria-label":"main navigation"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-menu",class:{ 'is-active' : _vm.isActive }},[_c('div',{staticClass:"navbar-start"},[_c('router-link',{staticClass:"navbar-item r-item",attrs:{"to":"/"}},[_c('span',{on:{"click":_vm.toggleNav}},[_vm._v("Home")])]),_vm._v(" "),_c('router-link',{staticClass:"navbar-item r-item",attrs:{"to":"/faq"}},[_c('span',{on:{"click":_vm.toggleNav}},[_vm._v("樂土Q&A")])]),_vm._v(" "),_c('router-link',{staticClass:"navbar-item r-item",attrs:{"to":"/product"}},[_c('span',{on:{"click":_vm.toggleNav}},[_vm._v("樂土產品列表")])]),_vm._v(" "),_c('router-link',{staticClass:"navbar-item r-item",attrs:{"to":"/contact"}},[_c('span',{on:{"click":_vm.toggleNav}},[_vm._v("聯絡我們")])]),_vm._v(" "),_c('a',{staticClass:"navbar-item r-item blog",attrs:{"href":"https://blog.ezarch.com.tw","target":"_blank"},on:{"click":_vm.toggleNav}},[_vm._v("官方部落格")])],1),_vm._v(" "),_vm._m(1,false,false)])])])]),_vm._v(" "),_c('main',[_c('router-view')],1),_vm._v(" "),_c('footer',{staticClass:"footer is-primary"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns is-gapless"},[_c('div',{staticClass:"column"},[_c('ul',{staticClass:"links"},[_c('li',[_c('router-link',{attrs:{"to":"/"}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-home fa-lg",attrs:{"aria-hidden":"true"}})]),_vm._v("Home")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/faq"}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-question-circle fa-lg",attrs:{"aria-hidden":"true"}})]),_vm._v("樂土Q&A")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/product"}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-shopping-cart fa-lg",attrs:{"aria-hidden":"true"}})]),_vm._v("產品列表")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/contact"}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-connectdevelop fa-lg",attrs:{"aria-hidden":"true"}})]),_vm._v("聯絡我們")])],1),_vm._v(" "),_vm._m(2,false,false)])]),_vm._v(" "),_vm._m(3,false,false),_vm._v(" "),_vm._m(4,false,false),_vm._v(" "),_c('div',{staticClass:"column"},[_c('p',[_vm._m(5,false,false),_vm._v(_vm._s(_vm.thisYear)+" EZARCH.inc  版權所有.")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fb-like",attrs:{"data-href":"https://www.facebook.com/ezarchs","data-layout":"button_count","data-action":"like","data-size":"small","data-show-faces":"false","data-share":"false"}},[_c('iframe',{staticStyle:{"border":"none","overflow":"hidden"},attrs:{"src":"https://www.facebook.com/plugins/like.php?href=https%3A%2F%2Fwww.facebook.com%2Fezarchs&width=75&layout=button_count&action=like&size=small&show_faces=false&share=false&height=21&appId=1350135241775221","width":"75","height":"21","scrolling":"no","frameborder":"0","allowTransparency":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-end"},[_c('div',{staticClass:"navbar-item"},[_c('a',{staticClass:"button is-primary is-outlined call-in-action",attrs:{"href":"https://shop.ezarch.com.tw","target":"_blank"}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-credit-card"})]),_vm._v(" "),_c('span',[_vm._v("購買樂土產品")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"https://blog.ezarch.com.tw","target":"_blank"}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-info-circle fa-lg",attrs:{"aria-hidden":"true"}})]),_vm._v("官方部落格")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column"},[_c('ul',{staticClass:"contact"},[_c('li',[_c('a',{attrs:{"href":"mailto:service@ezarch.com.tw"}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-envelope-o fa-lg",attrs:{"aria-hidden":"true"}})]),_vm._v("service@ezarch.com.tw")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"tel:0931247688"}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-mobile fa-lg",attrs:{"aria-hidden":"true"}})]),_vm._v("0931-247-688")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"tel:0287976155"}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-phone-square fa-lg",attrs:{"aria-hidden":"true"}})]),_vm._v("02-87976155")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column"},[_c('ul',{staticClass:"social"},[_c('li',[_c('a',{attrs:{"href":"https://www.facebook.com/ezarchs/","target":"_blank"}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-facebook-official fa-lg"})]),_vm._v("Facebook粉絲團")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.instagram.com/ezarch55/","target":"_blank"}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-instagram fa-lg"})]),_vm._v("Instagram")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://line.me/ti/p/%40xqw0055x","target":"_blank"}},[_c('img',{attrs:{"border":"0","alt":"好友人數","src":"https://i2.wp.com/biz.line.naver.jp/line_business/img/btn/addfriends_zh-Hant.png?fit=720%2C36&ssl=1","width":"107","height":"36"}})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-copyright",attrs:{"aria-hidden":"true"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lO7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("Fs8J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77fa7f6e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("c/By");
function injectStyle (ssrContext) {
  __webpack_require__("H3hf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-77fa7f6e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77fa7f6e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "mmHi":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lotosanti2.a7d3588.jpg";

/***/ }),

/***/ "oKJ3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lotoslogo.8bbaff8.png";

/***/ }),

/***/ "vdOg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "x+ht":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/product3.6536a25.png";

/***/ }),

/***/ "xG8C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lotos',
  data: function data() {
    return {
      topValue: 0
    };
  },
  methods: {
    scrollToContent: function scrollToContent() {
      var main = document.getElementsByClassName('main-content')[0];
      function scrollToElement(element) {
        var el = element;
        var yPos = el.getClientRects()[0].top;
        var yScroll = window.scrollY;
        var i = 1;
        var interval = setInterval(function () {
          yScroll += 10;
          i++;
          if (i == 500) clearInterval(interval);

          window.scroll(0, yScroll);
          if (el.getClientRects()[0].top < 0) {
            clearInterval(interval);
          }
        }, 5);
      }
      scrollToElement(main);
    }
  },
  beforeMount: function beforeMount() {
    var self = this;
    setInterval(getTop, 100);
    var status = true;
    function getTop() {
      if (status) {
        self.topValue++;
        if (self.topValue == 5) {
          status = false;
        }
      } else {
        self.topValue--;
        if (self.topValue == 0) {
          status = true;
        }
      }
    }
    getTop();
  }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      isActive: false,
      thisYear: new Date().getFullYear()
    };
  },
  methods: {
    toggleNav: function toggleNav() {
      this.isActive = !this.isActive;
    }
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.7d97833d58bce6ab0ef9.js